import { BaseService } from './BaseService';
import { LabelPrintTask, LabelPrintTaskStatus } from '../models/labels';
import { PageableResult } from '../models/common';

export class LabelPrintTaskService extends BaseService {
  getLabelPrintTasks = async (page: number, size: number): Promise<PageableResult<LabelPrintTask>> => {
    const query = this.BuildQueryString({ page, size });

    const result = await this.Fetch(`/labelprint/tasks?${query}`, 'GET');

    return this.FromResult<PageableResult<LabelPrintTask>>(result);
  };

  getVetLabelPrintTasks = async (
    farmId: string,
    page: number,
    size: number
  ): Promise<PageableResult<LabelPrintTask>> => {
    const query = this.BuildQueryString({ farmId, page, size });

    const result = await this.Fetch(`/labelprint/tasks?${query}`, 'GET');

    return this.FromResult<PageableResult<LabelPrintTask>>(result);
  };

  updateLabelPrintTask = async (
    id: string,
    status: LabelPrintTaskStatus,
    printedCount: number,
    message: any,
    overriddenLotNumber?: string | null,
    overriddenTreatmentNumber?: string | null
  ): Promise<string> => {
    const command = {
      id,
      status,
      printedCount,
      message,
      ...(overriddenLotNumber != null && { overriddenLotNumber }),
      ...(overriddenTreatmentNumber != null && { overriddenTreatmentNumber })
    };
    const result = await this.Fetch('/labelprint/tasks', 'PUT', JSON.stringify(command));

    return this.FromResult<string>(result);
  };
}

export default LabelPrintTaskService;
